angular.module('common.services').factory('edgeFactory', [
  '$filter',
  '$http',
  '$localStorage',
  function ($filter, $http, $localStorage) {
    this.list = []
    this.findItemById = function (id) {
      var returnValue = {
        status: 0
      }
      const [item] = this.list.filter(e => e.id == id)
      if (item) {
        returnValue.status = 1
        returnValue.item = item
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }
    this.findItemByDeviceSerial = function (deviceSerial) {
      var returnValue = {
        status: 0
      }
      var item = $filter('filter')(this.list, function (e) {
        return e.uri == deviceSerial
      })
      if (item.length > 0) {
        returnValue.status = 1
        returnValue.item = item[0]
        returnValue.index = this.list.indexOf(returnValue.item)
      }
      return returnValue
    }
    this.addOrUpdateItem = function (item) {
      if (item.edge_type == 2 && item.locationStatus === undefined) {
        // create Enum
        // throw new Error();
      }
      var itemData = this.findItemById(item.id)
      if (itemData.status == 1) {
        this.list[itemData.index] = item
      } else {
        this.list.push(item)
      }
    }
    this.deleteItemById = function (id) {
      var itemData = this.findItemById(id)
      if (itemData.status == 1) {
        var index = itemData.index
        this.list.splice(index, 1)
      }
    }

    this.getDeviceStatuses = function (serialNumbers) {
      return $http({
        method: 'POST',
        url: `${EDGE_BASEURL}/rpc-devices-tunnel-status`,
        data: {
          serialNumbers
        },
        headers: {
          'x-hide-original-mqtt-device-state': false
        }
      }).then(response => {
        return response.data && response.data.devices
      })
    }
    return this
  }
])
